import { ElementRef } from '@angular/core';
import { SelectedRowContext } from '../entity/index';
import { GridComponent } from '@progress/kendo-angular-grid';

/**
 * å¤éåè¡¨å·¥å·ç±»
 */
export class MultiSelectGridUtility {
  static CURRENT_ROW_STYLE_NAME = 'f-state-selected';
  static CHECKBOXED_ROW_STYLE_NAME = 'f-state-checked';

  /**
   * æ¸²æåæ¢è¡
   */
  public static renderClickChangedRow(gridComponent: GridComponent, selectedRowContext: SelectedRowContext) {
    if (!gridComponent) {
      return;
    }

    const currentRowIndex = selectedRowContext.currentRowIndex;
    // æ¸²æå½åè¡
    this.addRowSelectedStyle(gridComponent, currentRowIndex);

    // æ¸²æä¸ä¸è¡
    const lastRowIndex = selectedRowContext.lastRowIndex;
    if (!this.checIfIsSameRelativeIndex(gridComponent, currentRowIndex, lastRowIndex)) {
      this.removeRowSelectedStyle(gridComponent, lastRowIndex);
    }
  }

  /**
   * æ£æ¥å½åè¡ç´¢å¼å¼åä¸ä¸ä¸ªéä¸­è¡ç´¢å¼å¼çç¸å¯¹å½åé¡µé¢çç´¢å¼å¼æ¯å¦ç¸å
   */
  private static checIfIsSameRelativeIndex(gridComponent: GridComponent, currentRowIndex: number, lastRowIndex: number): boolean {
    let isSameRelativeIndex = false;
    if (currentRowIndex === lastRowIndex) {
      isSameRelativeIndex = true;
      return isSameRelativeIndex;
    }

    if ((Math.abs(currentRowIndex - lastRowIndex)) % (gridComponent.pageSize) === 0) {
      isSameRelativeIndex = true;
      return isSameRelativeIndex;
    }

    return isSameRelativeIndex;
  }

  /**
   * æ£æµæ¯å¦å¯ç¨åé¡µåè½
   */
  public static checkIfEnablePaging(gridComponent: GridComponent): boolean {
    let isPageable = false; // é»è®¤æªå¯ç¨åé¡µ
    if (!gridComponent) {
      return isPageable;
    }

    if (typeof gridComponent.pageable === 'boolean') {
      isPageable = gridComponent.pageable;
    } else if (typeof gridComponent.pageable === 'object') {
      isPageable = true;
    }

    return isPageable;
  }

  /**
   * æ¸²æcheckboxéæ©
   */
  public static renderSelectedChangeCheckbox(elementRef: ElementRef, $event: any) {

    const currentRowIndex = $event.index;

    const trCollection = this.getTrCollection(elementRef);
    if (trCollection == null || trCollection.length <= 0 || trCollection.length < currentRowIndex) {
      return;
    }

    // æ¸²æcheckedè¡
    const currentTableRowElement = trCollection[currentRowIndex];
    if (!currentTableRowElement) {
      return;
    }

    if ($event.selected) { // checked
      this.appendAtrributeValue(currentTableRowElement, 'class', this.CHECKBOXED_ROW_STYLE_NAME);
    } else { // unchecked
      this.removeAttributeSpecificValue(currentTableRowElement, 'class', this.CHECKBOXED_ROW_STYLE_NAME);
    }
  }

  /**
   * æ·»å è¡çâå·²éä¸­æ ·å¼â
   * ææ éæ±ï¼ä¸å¯¹å¤æ´é²
   */
  private static addRowSelectedStyle(gridComponent: GridComponent, rowIndex: number) {
    if (!gridComponent || rowIndex < 0) {
      return;
    }

    const currentRowElement = this.getRelativeRowInCurrentPage(gridComponent, rowIndex);
    if (!currentRowElement) {
      return;
    }

    this.appendAtrributeValue(currentRowElement, 'class', this.CURRENT_ROW_STYLE_NAME);
  }

  /**
   * ç§»é¤è¡çâå·²éä¸­æ ·å¼â
   * éæ±ï¼kendo-gridå¨åé¡µæ¶ï¼ä¸ä¼ç§»é¤å·²éä¸­æ ·å¼
   */
  public static removeRowSelectedStyle(gridComponent: GridComponent, rowIndex: number) {
    if (!gridComponent || rowIndex < 0) {
      return;
    }

    const currentRowElement = this.getRelativeRowInCurrentPage(gridComponent, rowIndex);
    if (!currentRowElement) {
      return;
    }
    this.removeAttributeSpecificValue(currentRowElement, 'class', this.CURRENT_ROW_STYLE_NAME);
  }

  /**
   * è·åæå®è¡å¨å½åé¡µé¢å¯¹åºçè¡åç´ 
   */
  private static getRelativeRowInCurrentPage(gridComponent: GridComponent, rowIndex: number): any {
    let rowElementInCurrentPage: any = null;
    if (!gridComponent || rowIndex < 0) {
      return rowElementInCurrentPage;
    }

    const gridElement = gridComponent.wrapper;
    // å¯ç¨åé¡µåï¼éè¦æ´æ°å½åè¡
    const isPaging = this.checkIfEnablePaging(gridComponent);
    if (isPaging) {
      rowIndex = rowIndex % (gridComponent.pageSize); // å¯¹pageSizeåæ¨¡
    }

    const trCollection = this.getTrCollection(gridElement);
    if (trCollection == null || trCollection.length <= 0) {
      return rowElementInCurrentPage;
    }

    rowElementInCurrentPage = trCollection[rowIndex];

    return rowElementInCurrentPage;
  }

  /**
   * è·åå½ågridçtréå
   */
  private static getTrCollection(elementRef: ElementRef): any[] {
    if (!elementRef || !elementRef.nativeElement) {
      return null;
    }

    const kendoGridTbodyElements: any[] = elementRef.nativeElement.getElementsByTagName('tbody');
    if (!kendoGridTbodyElements || kendoGridTbodyElements.length <= 0) {
      return null;
    }

    const trCollection = kendoGridTbodyElements[0].getElementsByTagName('tr');
    return trCollection;
  }

  /**
   * ååç´ çæå®å±æ§è¿½å å¼
   */
  private static appendAtrributeValue(currentElement: Element, attributeName: string, attributeValue: string) {
    let newAttributeValue: string = currentElement.getAttribute(attributeName);
    if (newAttributeValue === null || newAttributeValue === '' || newAttributeValue.length <= 0) {
      newAttributeValue = attributeValue;
    } else {
      if (newAttributeValue.indexOf(attributeValue) < 0) { // å­å¨æ£æµï¼é¿åéå¤æ·»å 
        newAttributeValue += ' ' + attributeValue;
      }
    }

    currentElement.setAttribute(attributeName, newAttributeValue);
  }

  /**
   * ç§»é¤åæ°æ®æå®å±æ§çç¹æ§å±æ§å¼
   */
  private static removeAttributeSpecificValue(currentElement: Element, attributeName: string, needRemoveAttributeValue: string) {
    let lastClassAttributeValue = currentElement.getAttribute(attributeName);
    if (!lastClassAttributeValue) {
      return;
    }

    const index = lastClassAttributeValue.lastIndexOf(needRemoveAttributeValue);
    if (index < 0) {
      return;
    }

    const tempLastClassAttributeValue = lastClassAttributeValue.substring(0, index - 1);
    lastClassAttributeValue = tempLastClassAttributeValue + ' '
      + lastClassAttributeValue.substring(index + needRemoveAttributeValue.length);

    currentElement.setAttribute(attributeName, lastClassAttributeValue);
  }
}
